// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2sCPk","header":"PatientBlock_header__3RVh5","label":"PatientBlock_label__3gtTa","option":"PatientBlock_option__34Tf2"};